module.exports = __webpack_public_path__ + "static/media/Eidefut header.ead63401.png";